import {
  FETCH_QUEUES,
  FETCH_QUEUES_SUCCESS,
  FETCH_QUEUES_FAILURE,
  FETCH_QUEUE_COUNTS,
  FETCH_QUEUE_COUNTS_FAILURE,
  FETCH_QUEUE_COUNTS_SUCCESS,
  TRIGGER_SERVICE,
  TRIGGER_SERVICE_FAILURE,
  TRIGGER_SERVICE_SUCCESS,
  RETRY_DLQ_MESSAGES,
  RETRY_DLQ_MESSAGES_FAILURE,
  RETRY_DLQ_MESSAGES_SUCCESS,
  CLEAR_DLQ,
  CLEAR_DLQ_SUCCESS,
  CLEAR_DLQ_FAILURE,
} from './types'

export const fetchQueues = (accessToken) => ({
  type: FETCH_QUEUES,
  payload: { accessToken },
})

export const fetchQueuesSuccess = (data) => ({
  type: FETCH_QUEUES_SUCCESS,
  payload: data,
})

export const fetchQueuesFailure = (error) => ({
  type: FETCH_QUEUES_FAILURE,
  payload: error,
})

export const fetchQueueCounts = (queueId, accessToken) => ({
  type: FETCH_QUEUE_COUNTS,
  payload: { queueId, accessToken },
})

export const fetchQueueCountsSuccess = (queueId, counts) => ({
  type: FETCH_QUEUE_COUNTS_SUCCESS,
  payload: { queueId, counts },
})

export const fetchQueueCountsFailure = (queueId, error) => ({
  type: FETCH_QUEUE_COUNTS_FAILURE,
  payload: { queueId, error },
})

export const triggerService = (queueId, accessToken) => ({
  type: TRIGGER_SERVICE,
  payload: { queueId, accessToken },
})

export const triggerServiceSuccess = (queueId) => ({
  type: TRIGGER_SERVICE_SUCCESS,
  payload: { queueId },
})

export const triggerServiceFailure = (queueId, error) => ({
  type: TRIGGER_SERVICE_FAILURE,
  payload: { queueId, error },
})

export const retryDLQMessages = (queueId, accessToken) => ({
  type: RETRY_DLQ_MESSAGES,
  payload: { queueId, accessToken },
})

export const retryDLQMessagesSuccess = (queueId) => ({
  type: RETRY_DLQ_MESSAGES_SUCCESS,
  payload: { queueId },
})

export const retryDLQMessagesFailure = (queueId, error) => ({
  type: RETRY_DLQ_MESSAGES_FAILURE,
  payload: { queueId, error },
})

export const clearDLQ = (queueId, accessToken) => ({
  type: CLEAR_DLQ,
  payload: { queueId, accessToken },
})

export const clearDLQSuccess = (queueId) => ({
  type: CLEAR_DLQ_SUCCESS,
  payload: { queueId },
})

export const clearDLQFailure = (queueId, error) => ({
  type: CLEAR_DLQ_FAILURE,
  payload: { queueId, error },
})
